import { useNavigate } from "react-router-dom";
import MangroveSweetCorn from "../assets/mangrove-sweet-corn.png";

export function ProductDetails({ selectedProduct }) {
  const navigate = useNavigate();
  return (
    <div
      className='offcanvas custom-offcanvas offcanvas-end offcanvas-product-details'
      tabindex='-1'
      id='offcanvasExample'
      aria-labelledby='offcanvasExampleLabel'
    >
      <div className='offcanvas-header'>
        <div className='top-noter' />
      </div>
      <div className='offcanvas-body'>
        <div className='product-introduction'>
          <div className='product-title'>
            <h5>{selectedProduct?.fields?.productName}</h5>
            {selectedProduct?.fields?.shortDescription ? (
              <p>{selectedProduct?.fields?.shortDescription}</p>
            ) : null}
          </div>
          <button
            type='button'
            className='btn-close'
            data-bs-dismiss='offcanvas'
            aria-label='Close'
          />
        </div>
        <div className='content'>
          <div className='product-img-container'>
            <img
              src={
                selectedProduct?.fields?.image?.fields?.file?.url ??
                MangroveSweetCorn
              }
              alt='Mangrove Sweet Corn'
              className='img-fluid'
            />
          </div>
          <div className='price'>
            <p>Price</p>
            <p>
              $
              {Number(selectedProduct?.fields?.productPrice).toFixed(2) ??
                "0.00"}
            </p>
          </div>
          {selectedProduct?.fields?.longDescription ? (
            <div className='description'>
              <h5>About this product</h5>
              <p>{selectedProduct?.fields?.longDescription}</p>
            </div>
          ) : null}
          {selectedProduct?.fields?.ingredients ? (
            <div className='description'>
              <h5>Ingredients</h5>
              {selectedProduct?.fields?.ingredients?.split(",").map((el) => (
                <li key={el}>{el.trim()}</li>
              ))}
            </div>
          ) : null}
          {selectedProduct?.fields?.dishes ? (
            <div className='description'>
              <h5>🍽️ Dishes you can make</h5>
              <div className='meal-block'>
                <div className='tile-list'>
                  {selectedProduct?.fields?.dishes?.map((el, index) => (
                    <p key={index}>{el?.fields?.foodName}</p>
                  ))}
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
      <div className='offcanvas-footer'>
        <button onClick={() => navigate("/where-to-buy")}>
          Buy from closest store
        </button>
      </div>
    </div>
  );
}
